import React, { Component } from 'react';

import whole_food_icon from './../img/whole_food.svg';
import light_whole_food_icon from './../img/light_whole_food.svg';
import care_icon from './../img/care.svg';
import vegetarian_icon from './../img/vegetarian.svg';
import vegan_icon from './../img/vegan.svg';
import gluten_free_icon from './../img/gluten_free.svg';
import lactose_free_icon from './../img/lactose_free.svg';

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '172.17.0.1' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);


class CategoryResults extends Component {
  constructor(...args) {
    super(...args)
    this.handleLoadAllClick = this.handleLoadAllClick.bind(this);
  }

  handleLoadAllClick = function() {
    this.props.handleLoadAll(this.props.id)
  }

  render () {
    if (this.props.articles && this.props.articles.length > 0) {
      let whole_food_icon_tag = (
        <img src={whole_food_icon} title="Vollkost" alt="Vollkost" className="article-preview-icon" />
      )
      let light_whole_food_icon_tag = (
        <img src={light_whole_food_icon} title="leichte Vollkost" alt="leichte Vollkost" className="article-preview-icon" />
      )
      let care_icon_tag = (
        <img src={care_icon} title="Schonkost" alt="Schonkost" className="article-preview-icon" />
      )
      let vegetarian_icon_tag = (
        <img src={vegetarian_icon} title="vegetarisch" alt="vegetarisch" className="article-preview-icon" />
      )
      let vegan_icon_tag = (
        <img src={vegan_icon} title="vegan" alt="vegan" className="article-preview-icon" />
      )
      let gluten_free_icon_tag = (
        <img src={gluten_free_icon} title="Gluten frei" alt="Gluten frei" className="article-preview-icon" />
      )
      let lactose_free_icon_tag = (
        <img src={lactose_free_icon} title="Laktose frei" alt="Laktose frei" className="article-preview-icon" />
      )
      return (
        <div className="results"
             id={"results-for-" + this.props.id}
             style={{display: this.props.isActive ? 'block' : 'none' }}>
          <div className="results-header">
            {this.props.icon_white_url ? (<img src={this.props.icon_white_url} alt={this.props.title} className="results-header-icon" />) : ''}
            {this.props.title}
          </div>

          <div className="results-body">
            {this.props.articles.map( function(article) {
              let img = ''
              if (article.get_image_path) {
                var path = ''
                if (isLocalhost) {
                  path = 'http://172.17.0.1:8000' + article.get_image_path
                } else {
                  path = 'https://www.menue-concept.de' + article.get_image_path
                }
              } else {
                if (isLocalhost) {
                  path = 'http://172.17.0.1:8000' + "/static/img/placeholder.jpg"
                } else {
                  path = 'https://www.menue-concept.de' + "/static/img/placeholder.jpg"
                }
              }

              img = (
                <img src={path}
                     className="article-preview-img"
                     alt={article.product_title}/>
              )

              return (
                <a key={article.id}
                   className="article-preview-box-wrapper"
                   href={article.meta.html_url}>
                  <div className="article-preview-box">
                    <div className="article-preview-header">{article.product_title}</div>

                    <div className="article-preview-body">
                      <div className="article-preview-img-wrapper">
                        {img}
                      </div>
                      <div className="article-preview-text-wrapper">
                        <div style={{display:"inline-block", float:"right"}}>{article.content_per_item}</div>
                        Art-Nr. {article.title}
                      </div>
                      <div className="article-preview-icons-wrapper">
                        {article.is_whole_food ? whole_food_icon_tag : ''}
                        {article.is_light_whole_food ? light_whole_food_icon_tag : ''}
                        {article.is_care ? care_icon_tag : ''}
                        {article.is_vegetarian ? vegetarian_icon_tag : ''}
                        {article.is_vegan ? vegan_icon_tag : ''}
                        {article.is_gluten_free ? gluten_free_icon_tag : ''}
                        {article.is_lactose_free ? lactose_free_icon_tag : ''}
                      </div>
                    </div>
                  </div>
                </a>
              )
            })}

            <div className="results-spinner"
                 id={"results-spinner-for-" + this.props.id}
                 style={{display: this.props.isLoading ? 'block' : 'none'}}>
              <i className="fa fa-spinner fa-4x" aria-hidden="true"></i>
            </div>
          </div>

          {this.props.moreAvailable && (
            <div
              className="load-all-btn"
              id={"load-all-btn-" + this.props.id}
              onClick={this.handleLoadAllClick}>
                ALLE LADEN
            </div>
          )}
        </div>
      )
    } else {
      return (
        <div></div>
      )
    }
  }
}


export default CategoryResults;



// WEBPACK FOOTER //
// ./src/Components/CategoryResults.js